import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const LeadsWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default LeadsWrapper